<template>
  <div class="flexgj hover">
    <img src="/images/newpcImg/nlicon.png" alt="" class="nlicon" />
    <span
      class="nlClass"
      :style="{ fontWeight: showSelete ? 'bold' : '400' }"
      >{{ $t(`${country}`) }}</span
    >
    <img
      src="/images/newpcImg/buttom.png"
      class="rotebutoom"
      :class="showSelete ? 'rotetop' : 'rotebutoom'"
      alt=""
    />
  </div>
</template>

<script>
export default {
  props: {
    country: {
      type: String,
      default: "NL",
    },
    showSelete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      i18nCountry: "NL",
    };
  },
  methods: {},
  created() {
    console.log(this.country, "country");
  },
};
</script>

<style lang="scss" scoped>
.flexgj {
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  height: 1.5385rem;
  .rotebutoom {
    width: 0.5385rem;
    height: 0.5385rem;
  }
  .rotetop {
    transform: rotate(180deg) !important;
    width: 0.5385rem !important;
    height: 0.5385rem !important;
    transform: all 0.5 !important;
  }
  .nlicon {
    width: 0.7692rem;
    height: 0.7692rem;
  }
  .hover:hover {
    span {
      font-weight: bold;
    }

    .nlClass {
      font-weight: bold;
    }
  }
}
</style>


// WEBPACK FOOTER //
// resources/js/components/spans.vue